import styles from "../styles/integrations.module.scss";

import { Title } from "../shared/components/Title";
import { useEffect } from "react";

export default function Bling() {
  const getSubtitle = () => {
    return "";
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (code && window.opener) {
      window.opener.postMessage({ type: "OAUTH_CODE", code }, window.origin);
    }
  }, []);

  return (
    <div className={styles.integrationsContainer}>
      <Title title="Bling - Vinculo da conta" subtitle={getSubtitle()} />

      <h1>Conectado..</h1>
    </div>
  );
}
